module.exports = __webpack_public_path__ + "img/330.59ba55f3.jpg";